import { render, staticRenderFns } from "./ResetPass.vue?vue&type=template&id=55df6b94&scoped=true"
import script from "./ResetPass.vue?vue&type=script&lang=js"
export * from "./ResetPass.vue?vue&type=script&lang=js"
import style0 from "./ResetPass.vue?vue&type=style&index=0&id=55df6b94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55df6b94",
  null
  
)

export default component.exports